import { render, staticRenderFns } from "./sxRecord.vue?vue&type=template&id=0c29074e&scoped=true"
import script from "./sxRecord.vue?vue&type=script&lang=js"
export * from "./sxRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29074e",
  null
  
)

export default component.exports